export const SEARCH_CONFIGURATIONS_DEFAULT_PAGE = 0;
export const SEARCH_CONFIGURATIONS_DEFAULT_SIZE = 3;
export const CUSTOMER_ID_COOKIE_NAME = 'customerId';
export const UNAUTHORIZED_CUSTOMER_ID_COOKIE_NAME = '_ym_uid';
export const SEARCH_CONFIGURATIONS_ENDPOINT = '/project-configuration/search';
export const FLOOR_COVERING_CONFIGURATION_TYPE = 'FLOOR_COVERING';
export const ANY_ROOM_TYPE = 'any';
export const TAB_LIST = {
  AREA: 1,
  LENGTH_WIDTH: 0,
};
export const MAX_ROOMS_LENGTH = 3;
export const LAMINATE_CALCULATOR_IDS = [
  '66d04df7c1480f7c1f38d2c0',
  '66d0448a206ce857b374a704',
  '66d043db0f8f5b1e368859e6',
];
